export default __webpack_public_path__ + "static/media/EAST1030.34I-34155_-18401_0.4fbb3ea8.jpg";